// extracted by mini-css-extract-plugin
export default {"btnLogin":"Login_btnLogin__VvMEX"};